import Master from 'components/helper/Master'
import React from 'react'
function CategoryMaster() {
  return (
    <Master name={{name:"Category Master"}} getUrl={"/Admin/getallcategory"} deleteUrl={"/Admin/deletecategory"} updateurl={"/Admin/updatecategory"}addurl={"/Admin/addcategory"} 
    id={'CategoryId'}
    />
  )
}
export default CategoryMaster